export default __webpack_public_path__ + "static/media/middlefinger.b673c268.svg";